import Modal from 'components/Modal'
import LoyaltyRedemptionTx from 'views/MemberProfile/ManualTx/LoyaltyRedemptionTx'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const ModalLoyaltyRedemptionTx = ({
  title,
  open,
  onClose,
}: Props): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <LoyaltyRedemptionTx onClose={onClose} />
    </Modal>
  )
}

export default ModalLoyaltyRedemptionTx
